import Vue from 'vue';
import swal from 'sweetalert2';

Vue.mixin({
  methods: {
    async confirm(config = {}) {
      return swal({
        title: this.$t('plugin-swal.are-you-sure', 'are you sure ?'),
        text: this.$t('plugin-swal.no-coming-back', 'There is no coming back'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
        ...config,
      });
    },
  },
});
